import hash from 'hash.js'
import axios from 'axios'

class SecretLocalStorage {
  constructor () {
    this.apiUrl = 'https://korkeakoulu.kopiraittila.fi/'

    this.key = 'signedData'
    this.emailKey = 'signedEmail'
    this.signHashKey = 'signedKey'

    this.email = ''
    this.signHash = ''

    this.data = {}
    this.isInitialized = false
    this.isValid = false
    this.needCode = false
    this.sendingCode = 0

    this.setupAxios()
    this.getEmail()
    this.getHash()
    this.initData()
  }

  setupAxios () {
    this.instance = axios.create({
      baseURL: this.apiUrl + '/wp-json/userdata/v1/',
      timeout: 10000
    })
  }

  initStore (success = () => {}, failure = () => {}) {
    console.debug('initStore')
    if (this.signHash) {
      console.debug('hash exists')
      this.fetchData(() => {
        console.debug('fetched')
        this.isInitialized = true
        this.isValid = true
        success(this.getCode())
      })
      console.debug('after')
    } else {
      this.login({ success, failure })
    }
  }

  login (args) {
    const code = (args.code) ? args.code : ''
    const success = (typeof args.success === 'function') ? args.success : () => {}
    const failure = (typeof args.failure === 'function') ? args.failure : () => {}
    if (args.email) {
      this.setEmail(args.email)
    }
    if (this.email) {
      this.instance
        .post('/auth', { email: this.email, code })
        .then((response) => {
          this.setHash(response.data.key)
          this.isInitialized = true
          this.isValid = true
          this.needCode = false
          this.sendingCode = 0
          this.initData()
          success(this.getCode())
        })
        .catch((error) => {
          this.isInitialized = true
          if (error && error.response && error.response.status === 403) {
            this.needCode = true
            failure(2)
          } else {
            failure(99)
          }
        })
    } else {
      this.isInitialized = true
      failure(1)
    }
  }

  logout () {
    this.setEmail('')
    this.data = {}
  }

  fetchData (callback = () => {}) {
    this.instance
      .get('/data?key=' + this.signHash)
      .then(response => {
        const retData = this.parseData(response.data)
        if (retData) {
          this.mergeData(retData)
          this.writeStorage(this.data)
        }
        callback()
      })
      .catch(error => {
        if (error && error.response && error.response.status === 403) {
          // Hash not valid, invalidate store.
          this.isValid = false
          this.setHash('')
        }
      })
  }
  sendData (data) {
    if (data) {
      this.instance
        .post('/data', { data, key: this.signHash })
        .then(response => {
          // Success
        })
        .catch(error => {
          if (error && error.response && error.response.status === 403) {
            // Hash not valid, invalidate store.
            this.isValid = false
            this.setHash('')
          }
        })
    }
  }

  parseData (data) {
    try {
      const storeData = JSON.parse(data)
      if (storeData && this.genHash(storeData.data) === storeData.hash) {
        console.debug('Data parsed successfully')
        console.debug(storeData.data)
        return JSON.parse(storeData.data)
      }
    } catch (e) {
      console.debug('Data parsing failed')
    }
    return {}
  }

  setEmail (email) {
    if (this.email !== email) {
      this.setHash('')
      this.email = email
      window.localStorage.setItem(this.emailKey, email)
    }
  }
  getEmail (forceFetch = false) {
    if (forceFetch || !this.email) {
      const email = window.localStorage.getItem(this.emailKey)
      if (email !== undefined) {
        this.email = email
      }
    }
    return this.email
  }
  getHash () {
    const hash = window.localStorage.getItem(this.signHashKey)
    if (hash !== undefined) {
      this.signHash = hash
    }
    return this.signHash
  }

  getValue (key, def = '') {
    return (this.data[key] === undefined) ? def : this.data[key]
  }
  setValue (key, value = '') {
    this.initData(true)
    this.data[key] = value
    this.writeStorage(this.data)
    return true
  }

  initData (force = false) {
    if (this.isValid && (force || Object.keys(this.data).length === 0)) {
      this.mergeData(this.readStorage())
    }
    this.fetchData()
  }
  mergeData (data) {
    for (const key in data) {
      console.debug('Merging:', key, data[key])
      this.data[key] = data[key]
    }
    console.debug(this.data)
  }

  getLSKey (keyName = '') {
    if (!keyName) keyName = this.key
    return keyName + '_' + hash.sha256().update(this.signHash + this.email).digest('hex')
  }

  writeStorage (data) {
    if (!this.isValid) return false
    const jsonString = JSON.stringify(data)
    const storeData = {
      data: jsonString,
      hash: this.genHash(jsonString)
    }
    window.localStorage.setItem(this.getLSKey(), JSON.stringify(storeData))
    this.sendData(JSON.stringify(storeData))
    return true
  }
  readStorage (sync = true) {
    if (!this.isValid) return {}
    const storeDataString = window.localStorage.getItem(this.getLSKey())
    if (storeDataString) {
      return this.parseData(storeDataString)
    }
    return {}
  }
  exportStore () {
    this.initData(true)
    const hashData = window.localStorage.getItem(this.getLSKey())
    if (hashData !== undefined) {
      return hashData
    }
  }

  genHash (data, secret = '') {
    if (!secret) secret = this.signHash + this.secret
    return hash.hmac(hash.sha224, secret).update(data).digest('hex')
  }

  getCode () {
    if (!this.isValid) return ''
    return this.signHash.toUpperCase().substr(0, 6)
  }

  setHash (hash) {
    this.signHash = hash
    window.localStorage.setItem(this.signHashKey, this.signHash)
    if (hash === '') {
      this.isValid = false
    }
  }
  requestCode () {
    this.sendingCode = 1
    this.instance
      .post('/auth', { email: this.email, send: 'true' })
      .then(() => {
        this.sendingCode = 2
      })
  }
}

const secretStore = new SecretLocalStorage()

export default secretStore



// WEBPACK FOOTER //
// ./src/utils/localstorage.js